module.exports = __webpack_public_path__ + "static/media/signed_up.080ec04d.svg";